import { gql } from '@apollo/client';
import { ReplayStopInput, ReplayMetricsFields, Point } from './types';

// G6 保存手动版本快照（5 指标由前端带入，落库不再调算法）。成功返回 true，前端另拉 G7 刷新

export interface SaveReplayManualVersionInput extends ReplayMetricsFields {
    dspTaskId: number;               // 子路线 id，版本按它落库
    warehouseId?: number | null;
    areaId?: number | null;
    orderedStops: ReplayStopInput[]; // 手动顺序快照，含起 -1 / 终 -2
    // 处于导航档时已算好的轨迹：一并存表让 G8 直接命中缓存；为空则留空走懒加载
    navigationTrajectory?: Point[] | null;
}

export interface SaveReplayManualVersionResponse {
    saveReplayManualVersion: boolean;
}

export interface SaveReplayManualVersionVariables {
    input: SaveReplayManualVersionInput;
}

export const SAVE_REPLAY_MANUAL_VERSION = gql`
    mutation SaveReplayManualVersion($input: SaveReplayManualVersionInput!) {
        saveReplayManualVersion(input: $input)
    }
`;
